export const generateCostBasisPayload = (costBasisInfo, isBrokerage) => {
  if (!isBrokerage) {
    return {
      costBasisElections: [
        {
          accountDescriptor: {
            accountId: costBasisInfo.account.accountId,
            accountChecksum: costBasisInfo.account.accountChecksum,
            accountNumber: costBasisInfo.account.accountNumber,
            productType: costBasisInfo.account.productType,
            trpCode: costBasisInfo.account.trpCode,
            suppressFromView: false,
          },
          costBasisMethod: costBasisInfo.costBasisTypeIdsList.costBasisType.label,
          costBasisTypeId: costBasisInfo.costBasisTypeIdsList.costBasisType.value,
          disposition: {
            action: 'update',
          },
          eligibleToRevoke: costBasisInfo.eligibleToRevoke,
          pendingIndicator: costBasisInfo.pendingIndicator,
          userAgreement: costBasisInfo.averageCostText,
        },
      ],
    };
  } else {
    const {
      costBasisTypeIdsList: {
        dripCostBasisType,
        mutualFundCostBasisType,
        otherSecurityCostBasisType,
      },
    } = costBasisInfo;
    return {
      costBasisElections: [
        {
          accountDescriptor: {
            accountId: costBasisInfo.account.accountId,
          },
          brokerageCostBasisMethods: {
            mutualFundCostBasisMethod: mutualFundCostBasisType.label,
            mutualFundCostBasisTypeId: mutualFundCostBasisType.value,
            otherSecurityCostBasisMethod: otherSecurityCostBasisType.label,
            otherSecurityCostBasisTypeId: otherSecurityCostBasisType.value,
            dripCostBasisMethod: dripCostBasisType.label,
            dripCostBasisTypeId: dripCostBasisType.value,
          },
          disposition: {
            action: 'update',
          },
          userAgreement: costBasisInfo.averageCostText
        },
      ],
    };
  }
}